import React from 'react';
import PropTypes from 'prop-types';
import { request, URLs } from '../../request';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
// @material-ui/core
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
// core components
import GridItem from 'components/core/Grid/GridItem';
import Card from 'components/core/Card/Card';
import dashboardStyle from 'assets/jss/views/dashboardStyle';
import AssignmentIcon from '@material-ui/icons/Assignment';

const safeTotal = (source, requestType, key) => {
  if (
    typeof source[requestType] !== 'undefined' &&
    typeof source[requestType][key] !== 'undefined'
  ) {
    return source[requestType][key][0].total;
  }
  return 0;
};

const MetricRow = ({ classes, label, value }) => (
  <div className={classes.metricRow}>
    <div className={classes.metricRowIcon}>
      <AssignmentIcon />
    </div>
    <span className={classes.metricRowLabel}>{label}</span>
    <span className={classes.metricRowValue}>{value}</span>
  </div>
);

MetricRow.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const PendingProcessingRequestsList = ({ classes, requestType, totalPendingRequests }) => (
  <div>
    {totalPendingRequests ? (
      <div className={classes.metricList}>
        <MetricRow
          classes={classes}
          label="غير مسند"
          value={safeTotal(totalPendingRequests, requestType, 'initial')}
        />
        <MetricRow
          classes={classes}
          label="مسند"
          value={safeTotal(totalPendingRequests, requestType, 'assigned')}
        />
        <MetricRow
          classes={classes}
          label="مصعد للمصعد"
          value={safeTotal(totalPendingRequests, requestType, 'escalated')}
        />
        <MetricRow
          classes={classes}
          label="مصعد للجودة"
          value={safeTotal(totalPendingRequests, requestType, 'quality')}
        />
      </div>
    ) : (
      <CircularProgress size={28} className={classes.cardTitleEscalation} />
    )}
  </div>
);

const UserAchievementsList = ({ classes, requestType, dailyAccomplishment }) => (
  <div>
    {dailyAccomplishment ? (
      <div className={classes.metricList}>
        <MetricRow
          classes={classes}
          label="تمت الإجابة"
          value={safeTotal(dailyAccomplishment, requestType, 'answered')}
        />
        <MetricRow
          classes={classes}
          label="صُعّد للمصعد"
          value={safeTotal(dailyAccomplishment, requestType, 'escalated')}
        />
        <MetricRow
          classes={classes}
          label="صُعّد للجودة"
          value={safeTotal(dailyAccomplishment, requestType, 'quality')}
        />
        <MetricRow
          classes={classes}
          label="مقبول"
          value={safeTotal(dailyAccomplishment, requestType, 'approved')}
        />
        <MetricRow
          classes={classes}
          label="مرفوض"
          value={safeTotal(dailyAccomplishment, requestType, 'rejected')}
        />
        <MetricRow
          classes={classes}
          label="مرفوض ومحظور"
          value={safeTotal(dailyAccomplishment, requestType, 'rejected_blocked')}
        />
      </div>
    ) : (
      <CircularProgress size={28} className={classes.cardTitleEscalation} />
    )}
  </div>
);

PendingProcessingRequestsList.propTypes = {
  classes: PropTypes.object.isRequired,
  requestType: PropTypes.string.isRequired,
  totalPendingRequests: PropTypes.object.isRequired,
};

UserAchievementsList.propTypes = {
  classes: PropTypes.object.isRequired,
  dailyAccomplishment: PropTypes.object.isRequired,
  requestType: PropTypes.string.isRequired,
};

class Dashboard extends React.Component {
  state = {};

  async componentDidMount() {
    const res = await request.GET(URLs.backoffice.DASHBOARD);
    /* eslint-disable-next-line no-unused-expressions */
    res.data &&
      this.setState({
        averageReponseTime: Math.round(res.data.average_response_time / 60),
        dailyAccomplishment: res.data.daily_accomplishment_for_the_user,
        totalPendingRequests: res.data.total_postponed_requests,
        totalEscalated: res.data.total_escalated_requests,
      });
  }

  render() {
    const { classes } = this.props;
    const {
      totalPendingRequests,
      totalEscalated,
      averageReponseTime,
      dailyAccomplishment,
    } = this.state;
    return (
      <div className={classes.root}>
        <div className={classes.dashboardTitle}>
          <h2 className={classes.pageTitle}>اللوحة الرئيسية</h2>
          <p className={classes.pageSubtitle}>نظرة سريعة على الطلبات المعلقة ومعدلات الإنجاز</p>
        </div>

        <Grid container>
          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.metricCard}>
              <p className={`${classes.metricValue} ${classes.cardTitleProcessing}`}>
                {averageReponseTime || averageReponseTime === 0 ? (
                  averageReponseTime
                ) : (
                  <CircularProgress size={28} className={classes.cardTitleProcessing} />
                )}
              </p>
              <p className={classes.metricLabel}>متوسط وقت المعالجة (دقيقة)</p>
              <hr className={classes.metricDivider} />
              <p
                className={`${classes.metricValue} ${classes.cardTitleEscalation}`}
                style={{ fontSize: 32 }}
              >
                {totalEscalated || totalEscalated === 0 ? (
                  totalEscalated
                ) : (
                  <CircularProgress size={28} className={classes.cardTitleEscalation} />
                )}
              </p>
              <p className={classes.metricLabel}>إجمالي الطلبات المصعدة</p>
            </Card>
          </GridItem>
        </Grid>

        <p className={classes.sectionTitle}>الطلبات المعلقة</p>
        <Grid container>
          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>إصدار التأشيرات</p>
              <PendingProcessingRequestsList
                classes={classes}
                requestType="VISA"
                totalPendingRequests={totalPendingRequests}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>نقل خدمات · فرد لفرد</p>
              <PendingProcessingRequestsList
                classes={classes}
                requestType="DLT_INDIVIDUALS"
                totalPendingRequests={totalPendingRequests}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>نقل خدمات · منشأة لفرد</p>
              <PendingProcessingRequestsList
                classes={classes}
                requestType="DL_TRANSFER"
                totalPendingRequests={totalPendingRequests}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>إصدار الإشعارات</p>
              <PendingProcessingRequestsList
                classes={classes}
                requestType="NOTICE"
                totalPendingRequests={totalPendingRequests}
              />
            </Card>
          </GridItem>
        </Grid>

        <p className={classes.sectionTitle}>إنجازك اليومي</p>
        <Grid container>
          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>إصدار التأشيرات</p>
              <UserAchievementsList
                classes={classes}
                requestType="VISA"
                dailyAccomplishment={dailyAccomplishment}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>نقل خدمات · فرد لفرد</p>
              <UserAchievementsList
                classes={classes}
                requestType="DLT_INDIVIDUALS"
                dailyAccomplishment={dailyAccomplishment}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>نقل خدمات · منشأة لفرد</p>
              <UserAchievementsList
                classes={classes}
                requestType="DL_TRANSFER"
                dailyAccomplishment={dailyAccomplishment}
              />
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <Card className={classes.card}>
              <p className={classes.cardHeaderLabel}>إصدار الإشعارات</p>
              <UserAchievementsList
                classes={classes}
                requestType="NOTICE"
                dailyAccomplishment={dailyAccomplishment}
              />
            </Card>
          </GridItem>
        </Grid>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export default withStyles(dashboardStyle)(Dashboard);
